import React from 'react';
import PropTypes from 'prop-types';

const CODES = [
  'USD',
  'GBP',
  'EUR',
  'AUD',
  'CAD',
  'SEK',
  'RUB',
];

export default function CurrencySelector({ value, onChange }) {
  return (
    <select
      name="currencyCode"
      id="currency-code"
      style={{ border: '2px solid #666666', borderRadius: 2, marginLeft: 8 }}
      onChange={onChange}
      value={value}
    >
      {CODES.map(code => <option key={code} value={code}>{code}</option>)}
    </select>
  );
}

CurrencySelector.displayName = 'CurrencySelector';

CurrencySelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};